import { items } from "@api/stores/salesInvoices/returns/items/path";
import { reclaim } from "@api/stores/salesInvoices/returns/reclaim/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/sales-invoices/:salesInvoiceId/returns`;
const pathById = `${pathBase}:returnId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const returns = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  items,
  reclaim,
};
